<template>
  <div class="container-370 mt-40">
    <div class="meeting-card-success">
        <p class="main-title text-center mb-10">以下の内容で予約して良いですか？</p>
        <div class="meeting-card-success-body text-center w-370">
            <div class="meeting-date mb-10">
              {{meeting.time.start.format('Y年 MM月 DD日')}}
              ({{meeting.time.start.day() | dayOfWeekLabel}})
            </div>
            <div class="meeting-time mb-10">{{meeting.time.start.format('HH:mm')}}〜{{meeting.time.end.format('HH:mm')}}</div>
            <div class="meeting-type mb-20">{{meetingCategories.find(n => n.id === meeting.category).name_kanji}}</div>
            <div class="meeting-users mb-20 mt-20">
              <p v-for="item in meeting.selectedUsers" :key="item.id">
                {{item.name || item.user_name}}
                <span v-if="item.type === USER_TYPE_PATIENT || item.user_type === USER_TYPE_PATIENT">(患者)</span>
                <span v-if="item.type === USER_TYPE_PHARMACIST || item.user_type === USER_TYPE_PHARMACIST">(薬剤師)</span>
                <span v-if="(item.type === USER_TYPE_OTHER && item.occupation && item.occupation !== '') || item.user_type === USER_TYPE_OTHER && item.user_occupation && item.user_occupation !== ''">({{item.occupation || item.user_occupation}})</span>
              </p>
              <p>
                {{$auth.user().name}}
                <span v-if="$auth.user().type === USER_TYPE_PHARMACIST">(薬剤師)</span>
                <span v-if="$auth.user().type === USER_TYPE_OTHER && $auth.user().occupation && item.occupation !== ''" >{{`(${$auth.user().occupation})`}}</span> - 主催者
              </p>
            </div>
            <div class="meeting-content">{{meeting.title}}</div>
        </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {USER_TYPE_OTHER, USER_TYPE_PATIENT, USER_TYPE_PHARMACIST} from '@/const'

export default {
  data () {
    return {
      USER_TYPE_PHARMACIST,
      USER_TYPE_PATIENT,
      USER_TYPE_OTHER
    }
  },
  props: {
    meeting: {type: Object, required: true}
  },
  computed: {
    ...mapGetters({
      meetingCategories: 'meetings/categories'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create-online/Confirm.vue